import { render } from "./form-control.vue?vue&type=template&id=451dd68f"
import script from "./form-control.vue?vue&type=script&lang=js"
export * from "./form-control.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__